import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { carwashTrolleys } from '../data/products';
import './TrolleyDetails.css';
import EmailPopup from '../components/EmailPopup';

const TrolleyDetails = () => {
  const { id } = useParams();
  const [selectedImage, setSelectedImage] = useState(0);
  const [showEmailPopup, setShowEmailPopup] = useState(false);
  const [emailConfirmed, setEmailConfirmed] = useState(false);

  const trolley = carwashTrolleys.find(t => t.id === parseInt(id));

  console.log('Trolley Details - Trolley found:', trolley);
  if (trolley) {
    console.log('Trolley image path:', trolley.image);
    console.log('Trolley gallery paths:', trolley.gallery);
  }

  if (!trolley) {
    return (
      <div className="trolley-not-found">
        <div className="container">
          <h2>Trolley Not Found</h2>
          <p>The trolley you're looking for doesn't exist.</p>
          <Link to="/car-wash-trolley" className="btn btn-primary">
            Back to Trolleys
          </Link>
        </div>
      </div>
    );
  }

  const handleEmailSubmit = (email, product) => {
    setShowEmailPopup(false);
    setEmailConfirmed(true);
  };

  const d = trolley.details || {};

  // Build metrics rows — show all that exist
  const metricsRows = [
    d.tankCapacity   && { label: 'Tank Capacity',    value: d.tankCapacity },
    d.powerSupply    && { label: 'Power Supply',      value: d.powerSupply },
    d.workingCurrent && { label: 'Working Current',   value: d.workingCurrent },
    d.ProductSize    && { label: 'Product Size',      value: d.ProductSize.trim() },
    d.PackageSize    && { label: 'Package Size',      value: d.PackageSize.trim() },
    d.bodyMaterial   && { label: 'Body Material',     value: d.bodyMaterial },
    d.wheelType      && { label: 'Wheel Type',        value: d.wheelType },
  ].filter(Boolean);

  // If no extra metrics exist yet, still show sizes + colors
  const basicRows = [
    d.ProductSize    && { label: 'Product Size',      value: d.ProductSize.trim() },
    d.PackageSize    && { label: 'Package Size',      value: d.PackageSize.trim() },
  ].filter(Boolean);

  const specRows = metricsRows.length > 0 ? metricsRows : basicRows;

  return (
    <div className="trolley-details-page">
      <div className="trolley-details section">
        <div className="container">
          <div className="breadcrumb">
            <Link to="/car-wash-trolley">Car Wash Trolleys</Link> / {trolley.title}
          </div>

          <div className="trolley-details-grid">
            {/* Images */}
            <div className="trolley-images">
              <div className="main-image">
                <img
                  src={`/${trolley.gallery.large[selectedImage] || trolley.image}`}
                  alt={trolley.title}
                  onError={(e) => { e.target.src = `/${trolley.image}`; }}
                />
              </div>
              <div className="thumbnail-images">
                {trolley.gallery.thumbs.map((thumb, index) => (
                  <div
                    key={index}
                    className={`thumbnail ${selectedImage === index ? 'active' : ''}`}
                    onClick={() => setSelectedImage(index)}
                  >
                    <img
                      src={`/${thumb}`}
                      alt={`${trolley.title} ${index + 1}`}
                      onError={(e) => { e.target.style.display = 'none'; }}
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Info */}
            <div className="trolley-info">
              <div className="trolley-category">{trolley.category}</div>
              <h1 className="trolley-title">{trolley.title}</h1>
              <div className="trolley-brand">
                <span>Brand: {trolley.brand}</span>
              </div>

              <div className="trolley-description">
                <p>{trolley.description}</p>
              </div>

              {/* Full Description */}
              {d.fullDescription && (
                <div className="trolley-details-section">
                  <h3>Product Details</h3>
                  <div className="details-content">
                    <p>{d.fullDescription}</p>
                  </div>
                </div>
              )}

              {/* ── Product Metrics Table (all trolleys) ── */}
              {specRows.length > 0 && (
                <div className="trolley-metrics">
                  <h3>Specifications</h3>
                  <div className="metrics-table-wrapper">
                    <div className="metrics-table-header">PRODUCT METRICS</div>
                    <table className="metrics-table">
                      <tbody>
                        {specRows.map((row, i) => (
                          <tr key={i}>
                            <td className="metrics-label">{row.label}</td>
                            <td className="metrics-value">{row.value}</td>
                          </tr>
                        ))}

                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* ── Key Features ── */}
              <div className="trolley-features">
                <h3>Key Features</h3>
                {d.keyFeatures && d.keyFeatures.length > 0 ? (
                  <ul className="features-list">
                    {d.keyFeatures.map((f, i) => (
                      <li key={i}>
                        <strong>{f.label}:</strong> {f.desc}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <ul className="features-list">
                    <li>Durable fiberglass reinforced plastic construction</li>
                    <li>12V, 35A battery operation</li>
                    <li>Working pressure: 4.5–4.8 A</li>
                    <li>Rubberized wheels for smooth mobility</li>
                    <li>Copper clip wiring for efficient connection</li>
                    <li>Illuminated push button switch</li>
                    <li>Includes spray gun, connectors, filter, and pipe</li>
                  </ul>
                )}
              </div>

              {/* Actions */}
              <div className="trolley-actions">
                <a
                  href={`https://wa.me/96898520852?text=I%20am%20interested%20in%20this%20product:%20${encodeURIComponent(trolley.title)}`}
                  className="btn btn-primary"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-whatsapp"></i> Inquire on WhatsApp
                </a>
                <Link to="/contact" className="btn btn-secondary">
                  Contact Us
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── Standard Accessory Kit Card (only if product has it) ── */}
      {d.accessoryKit && (
        <section className="accessory-kit-section section">
          <div className="container">
            <div className="accessory-kit-card">
              <div className="accessory-kit-icon">
                <i className="fas fa-toolbox"></i>
              </div>
              <div className="accessory-kit-content">
                <h3>Standard Accessory Kit Included</h3>
                <p>{d.accessoryKit}</p>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Color Variations Section */}
      {d.avilableColors && (
        <section className="color-variations-section section">
          <div className="container">
            <div className="section-title-left">
              <h3>Available Color Variations</h3>
            </div>
            <div className="color-variations-grid">
              {d.avilableColors.split(',').map((color, index) => (
                <div key={index} className="color-variation-item">
                  {color.trim()}
                </div>
              ))}
            </div>
            <hr className="color-variations-divider" />
            <p className="color-variations-notice">
              For fleet procurement, commercial pricing, or custom branding layouts, please contact your regional distributor.
            </p>
          </div>
        </section>
      )}

      {showEmailPopup && (
        <EmailPopup
          open={showEmailPopup}
          onClose={() => setShowEmailPopup(false)}
          onSubmit={handleEmailSubmit}
          product={trolley}
        />
      )}
      {emailConfirmed && (
        <div className="product-confirmation" style={{ textAlign: 'center', margin: '2rem 0' }}>
          <h3>Thank you for your interest!</h3>
          <p>We have received your email. (Mock confirmation. Payment integration coming soon.)</p>
          <button className="btn btn-primary" onClick={() => setEmailConfirmed(false)}>Close</button>
        </div>
      )}
    </div>
  );
};

export default TrolleyDetails;